import React from 'react';
import ReactDOM from 'react-dom';

export default class ReCAPTCHA extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      widgetId: undefined,
    };
  }

  componentDidMount() {
    this.explicitRender();
  }

  componentDidUpdate() {
    this.explicitRender();
  }

  getValue() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this.state.widgetId);
    }
    return null;
  }

  reset() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      this.props.grecaptcha.reset(this.state.widgetId);
    }
  }

  handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  }

  explicitRender(cb) {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
      const id = this.props.grecaptcha.render(this.refs.captcha, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        'expired-callback': this.handleExpired,
        size: this.props.size,
        stoken: this.props.stoken,
      });

      this.setState({
        widgetId: id,
      });
    }
  }

  render() {
    const {
      sitekey,
      onChange,
      theme,
      type,
      tabindex,
      onExpired,
      size,
      stoken,
      grecaptcha,
      ...childProps
    } = this.props;
    return <div {...childProps} ref="captcha" />;
  }
}

ReCAPTCHA.propTypes = {
  sitekey: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  grecaptcha: React.PropTypes.object,
  theme: React.PropTypes.oneOf(['dark', 'light']),
  type: React.PropTypes.oneOf(['image', 'audio']),
  tabindex: React.PropTypes.number,
  onExpired: React.PropTypes.func,
  size: React.PropTypes.oneOf(['compact', 'normal']),
  stoken: React.PropTypes.string,
};
